export default __webpack_public_path__ + "static/media/profile1.c61e25ac.jpeg";